import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from 'dabbl-react-components';

import {RETAILER_NAME, REATILER_CARD_IMAGE} from "../../retailerValues";

class ShopriteCard extends Component {

  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    const { className } = this.props;
    return (
      <ResponsiveImage
        className={`ShopriteCard ${className}`}
        src={REATILER_CARD_IMAGE}
        alt={`${RETAILER_NAME} Card`}
      />
    );
  }
}

export default ShopriteCard;



// WEBPACK FOOTER //
// ./src/components/ShopriteCard/ShopriteCard.js